import { render, staticRenderFns } from "./Cargar.vue?vue&type=template&id=fa7793b2&"
import script from "./Cargar.vue?vue&type=script&lang=js&"
export * from "./Cargar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports